<script>
import ListAction from './ListAction.vue';

/**
 * The Recusal component.
 */
export default {
  extends: ListAction
};
</script>
